//@flow
import React from 'react';
import HorizontalCarousel from 'components/molecules/horizontalCarousel';
import { PaginationControl } from 'components/molecules/paginationControl';

type Props = {};

export const OverlayImageCarousel = (props: Props) => {
  const {
    Images,
    className,
    cssFor,
    type,
    activeSlide,
    setActiveSlide,
    next,
    previous,
    handleSliderRef,
    key,
  } = props;

  const renderImageContent = () => (
    <div className={className}>
      {Images ? (
        <HorizontalCarousel
          data={Images}
          type={type}
          cssFor={cssFor}
          getActiveSlide={e => {
            setActiveSlide(e);
          }}
          handleSliderRef={handleSliderRef}
        />
      ) : null}
      {renderCarousalFooter()}
    </div>
  );

  const renderCarousalFooter = () => (
    <PaginationControl
      className={'section-footer-item'}
      theme={'light-theme'}
      currentIndex={activeSlide + 1}
      total={Images.length}
      onNextClick={next}
      onPreviousClick={previous}
      key={key}
    />
  );

  return <>{renderImageContent()}</>;
};
